'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useAuth } from '@/contexts/AuthenticationContext';
import { useBookStore } from '@/stores/useBookStore';

export function SentryUserInitializer() {
  const { user } = useAuth();
  const currentWorkId = useBookStore((state) => state.currentWorkId);

  useEffect(() => {
    // Only set Sentry user in production or if explicitly enabled for other environments
    // For now, aligning with the original logic which checks NODE_ENV
    if (process.env.NODE_ENV !== 'production') return;

    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.email ?? undefined,
        custom_data: {
          currentWorkId: currentWorkId ?? 'N/A',
        },
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user, currentWorkId]);

  return null; // This component does not render any UI
}
